'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { clsx } from '@/libs';

type BottomFixedHeaderProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const BottomFixedHeader = ({
  children,
  className,
  ...props
}: BottomFixedHeaderProps) => {
  return (
    <div className={clsx('w-full', className)} {...props}>
      {children}
    </div>
  );
};
